import React, { PropsWithChildren } from 'react'
import { css } from '@emotion/css'
import { FormattedMessage, useIntl } from 'react-intl'
import { LibraryAgentLanguage } from '../library/library-agent-language'
import { Tooltip } from '@contrast-security-inc/design-system-popovers'
import { Link } from '@contrast-security-inc/design-system-typography'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { LibraryCommonUIProps } from '../../helpers/libraries-interfaces'

type Props = {
  language?: LibraryCommonUIProps['language']
}

const BoldComponent = (chunks: any) => <b>{chunks}</b>
const LinkComponent = (chunks: any) => {
  const { formatMessage } = useIntl()

  return (
    <Link
      href={formatMessage({
        id: 'link_viewLibrariesMostRecent'
      })}
      isExternal
      className={css`
        &&& {
          color: ${theme.color.turquoise50};
        }
      `}
    >
      {chunks}
    </Link>
  )
}

export const DotnetTooltip: React.FC<PropsWithChildren<Props>> = ({
  children,
  language
}) => {
  return (
    <>
      {typeof language === 'string' &&
      language.toLowerCase() ===
        LibraryAgentLanguage.DOTNET.getValue().toLowerCase() ? (
        <>
          <Tooltip
            body={
              <FormattedMessage
                id="detail_libraries_dotnetPackageUpgrade"
                values={{
                  bold: BoldComponent,
                  link: LinkComponent
                }}
              />
            }
            interactive
          >
            <div
              className={css`
                width: min-content;
              `}
            >
              {children}
            </div>
          </Tooltip>
        </>
      ) : (
        children
      )}
    </>
  )
}
